<i [ngClass]="iconClass$|async"></i>
